import React from 'react';
import {toAbsoluteUrl} from '../../../../../../../_metronic/_helpers';
import PropTypes from 'prop-types';
import DataItemSelectAsync
  from '../../../../../_common/components/DataItemSelectAsync';
import DataItem from '../../../../../_common/components/DataItem';
import {
  integerValue,
  floatValueSign
} from '../../../../../../../utils';
import DataItemSelect from '../../../../../_common/components/DataItemSelect';
import DataItemDatepicker
  from '../../../../../_common/components/DataItemDatepicker';
import {
  addReceiptGridSelectStyles
} from '../../../../../_common/styles/reactSelectStyles';
import {paymentTypeOptions} from '../../../../../_common/constants/options';
import {Button} from 'react-bootstrap';

const ReceiptItem = ({
                       agent,
                       description,
                       paymentType,
                       dueDate,
                       checkNumber,
                       bankCode,
                       branchNumber,
                       accountNumber,
                       amount,
                       values,
                       findAgentAction,
                       getInvoicesList,
                       setPopupRowIndex,
                       index,
                       onRemove
                     }) => {
  const cellClassName = `d-flex align-items-center w-100 px-1`;

  return (
    <div key={index} className="d-flex align-items-center py-1">
      <div className="d-flex justify-content-between w-100">
        {(values.multipleAgents && values.receiptType === 'existing') &&
          <DataItemSelectAsync
            fieldId={agent}
            containerStyle={cellClassName}
            inputContainerStyle={cellClassName}
            customStyles={addReceiptGridSelectStyles}
            loadOptions={findAgentAction}
            getOptionLabel={e => (`${e._id} - ${e.fullName}`)}
            getOptionValue={e => e._id}
          />
        }
        <DataItem
          fieldId={description}
          containerStyle={cellClassName}
        />
        <DataItemSelect
          fieldId={paymentType}
          containerStyle={cellClassName}
          inputContainerStyle={cellClassName}
          options={paymentTypeOptions}
          customStyles={addReceiptGridSelectStyles}
        />
        {values.receiptType !== 'new' && (
          <DataItemDatepicker
            fieldId={dueDate}
            containerStyle={cellClassName}
          />
        )}
        <DataItem
          fieldId={checkNumber}
          containerStyle={cellClassName}
          onChange={integerValue}
        />
        <DataItem
          fieldId={bankCode}
          containerStyle={cellClassName}
          onChange={integerValue}
        />
        <DataItem
          fieldId={branchNumber}
          containerStyle={cellClassName}
          onChange={integerValue}
        />
        <DataItem
          fieldId={accountNumber}
          containerStyle={cellClassName}
        />
        <DataItem
          dir={'ltr'}
          customInputStyle="text-left custom-data-item"
          fieldId={amount}
          containerStyle={cellClassName}
          onChange={floatValueSign}
        />
        {(values.multipleAgents && values.receiptType === 'existing') &&
          <div className={`d-flex align-items-center px-1 w-35px`}>
            <Button
              className="btn d-flex align-items-center justify-content-center h-25px w-25px custom-subheader-button"
              onClick={() => {
                getInvoicesList();
                setPopupRowIndex(index);
              }}
              disabled={!values.customer}
            >
              <img
                src={toAbsoluteUrl('/media/svg/Search_white.svg')}
                alt="receipt"
                className="h-20px"
              />
            </Button>
          </div>
        }
        <div className="d-flex align-items-center pl-2 justify-content-end">
          <Button
            className="btn btn-icon btn-light btn-sm custom-action-button h-25px w-30px mr-1"
            onClick={() => {
              if (Boolean(onRemove)) {
                onRemove(index);
              }
            }}
          >
            <img
              src={toAbsoluteUrl('/media/svg/Cross_brandColor.svg')}
              alt="remove-row"
              className="w-20px"
            />
          </Button>
        </div>
      </div>
    </div>
  );
};

ReceiptItem.propTypes = {
  description: PropTypes.string,
  paymentType: PropTypes.string,
  dueDate: PropTypes.string,
  checkNumber: PropTypes.string,
  bankCode: PropTypes.string,
  branchNumber: PropTypes.string,
  accountNumber: PropTypes.string,
  amount: PropTypes.string
};

export default ReceiptItem;
